// 九型体质疾病风险与饮食调理全览
export const bodyTypeData = {
  '平和质': {
    corePathology: '阴阳气血调和',
    diseaseRisks: '无特定疾病倾向，患病率低，身体适应能力强，即使生病也易于康复。',
    dietPrinciple: '平衡膳食，维持现状',
    recommendedFoods: [
      '多样化饮食：遵循《黄帝内经》"五谷为养，五果为助，五畜为益，五菜为充"的原则，确保营养全面。',
      '顺应四季：春季吃些辛甘发散之品（如韭菜、香椿），夏季适当吃些清热解暑之物（如西瓜、绿豆），秋季多吃滋阴润肺的食物（如梨、银耳），冬季可适度温补（如羊肉、核桃）。'
    ],
    strictProhibitions: [
      '避免长期偏食（如只吃素或只吃肉）。',
      '避免暴饮暴食，加重脾胃负担。',
      '避免过度依赖大补或大寒的食物，以免破坏平衡。'
    ]
  },
  '气虚质': {
    corePathology: '元气不足，脏腑功能衰退',
    diseaseRisks: '易感冒：卫外功能薄弱，对环境变化（如风寒）抵抗力差。内脏下垂：中气下陷，无法固摄，可能导致胃下垂、肾下垂、子宫脱垂、脱肛等。慢性疲劳综合征：持续性的疲乏无力，难以通过休息缓解。',
    dietPrinciple: '补中益气，健脾和胃',
    recommendedFoods: [
      '主食：糯米、小米、燕麦、山药。',
      '食材：鸡肉、牛肉、鳝鱼、香菇、土豆、南瓜。',
      '药材/辅料：黄芪（泡水或煲汤）、党参、太子参、大枣、蜂蜜。烹饪方式以炖、煮、焖、熬粥为主，易于吸收。'
    ],
    strictProhibitions: [
      '生冷食物：冰淇淋、冷饮、生鱼片、西瓜、苦瓜，以免损伤脾胃阳气。',
      '破气耗气之物：萝卜籽（莱菔子）、山楂、薄荷，不宜过量。',
      '油腻厚味：油炸食品，会增加消化负担，消耗元气。'
    ]
  },
  '阳虚质': {
    corePathology: '阳气不足，身体失于温煦',
    diseaseRisks: '痰饮、肿胀：水液代谢障碍，易导致慢性支气管炎、肺气肿、水肿。泄泻：脾肾阳虚，运化失常，导致慢性腹泻、五更泻（黎明前腹泻）。关节痛：寒湿侵袭，易患风湿性/类风湿性关节炎，遇冷加重。性功能减退：畏寒肢冷，腰膝酸软。',
    dietPrinciple: '温补元阳，散寒暖中',
    recommendedFoods: [
      '温热性食物：羊肉、狗肉、鹿肉、韭菜、生姜、桂圆、荔枝、核桃、栗子。',
      '调味品：多用姜、葱、蒜、肉桂、花椒、小茴香等热性香料。',
      '烹饪：多采用煲汤、炖煮的方式，可加入适量黄酒。'
    ],
    strictProhibitions: [
      '所有生冷：冰淇淋、冷饮、冰镇水果（尤其是西瓜、梨、香蕉）。',
      '寒性食物：螃蟹、田螺、苦瓜、绿豆、海带、冬瓜。',
      '忌过度饮水：尤其在晚间，以免加重水湿停滞。'
    ]
  },
  '阴虚质': {
    corePathology: '阴液亏少，不能制阳，虚火上炎',
    diseaseRisks: '虚劳、失精：身体慢性消耗，可能导致遗精、早泄、月经量少。失眠：心肾不交，虚火扰神，导致入睡困难、心烦失眠。便秘：肠液枯涸，导致大便干结如羊粪。干燥综合征：眼干、口干、皮肤干、阴道干涩。',
    dietPrinciple: '滋阴润燥，清热降火',
    recommendedFoods: [
      '滋润食材：银耳、百合、雪梨、甘蔗、豆浆、豆腐、鸭肉、猪肉皮、鸡蛋、牛奶、桑葚、枸杞子。',
      '清补：宜采用蒸、煮、炖、粥等温和的烹饪方式。'
    ],
    strictProhibitions: [
      '温燥辛辣：辣椒、花椒、羊肉、韭菜、肉桂、干姜、炒瓜子、炒花生。',
      '油炸煎烤：所有油炸食品都会耗伤阴液。',
      '忌熬夜：熬夜是伤阴的首要因素，需配合作息调理。'
    ]
  },
  '痰湿质': {
    corePathology: '脾失健运，水湿内停，聚湿成痰',
    diseaseRisks: '代谢性疾病：糖尿病、高脂血症、痛风。心脑血管病：中风、冠心病、心绞痛（胸痹）。多囊卵巢综合征：与痰湿体质密切相关。',
    dietPrinciple: '健脾祛湿，化痰泄浊',
    recommendedFoods: [
      '利水渗湿：红豆、薏米、白扁豆、冬瓜、黄瓜、鲫鱼。',
      '健脾化痰：山药、茯苓、陈皮、萝卜、洋葱、海带。',
      '烹饪：绝对清淡，多采用清炒、清蒸、煮汤。'
    ],
    strictProhibitions: [
      '肥甘厚腻：肥肉、动物内脏、油炸食品。',
      '甜腻黏滑：蛋糕、巧克力、奶茶、冰淇淋、糯米制品（如汤圆、年糕）。',
      '酒类：啤酒、白酒均会助湿生热，必须限制。'
    ]
  },
  '湿热质': {
    corePathology: '湿热蕴结，如油裹面，缠滞不畅',
    diseaseRisks: '皮肤问题：顽固性痤疮、毛囊炎、湿疹、脂溢性皮炎。肝胆疾病：黄疸、胆结石、胆囊炎。泌尿生殖系统感染：膀胱炎、尿道炎、阴道炎、前列腺炎。',
    dietPrinciple: '清热祛湿，宣畅气机',
    recommendedFoods: [
      '清热利湿：绿豆、苦瓜、黄瓜、冬瓜、芹菜、马齿苋、荸荠、茵陈（代茶饮）。',
      '利湿通淋：薏米、赤小豆、玉米须。'
    ],
    strictProhibitions: [
      '辛辣大热：辣椒、生姜、大蒜、羊肉、狗肉、鹿肉。',
      '甜腻食物：糖果、奶油、含糖饮料，因"甘能助湿"。',
      '酒精与咖啡：均为生湿助热之品。'
    ]
  },
  '血瘀质': {
    corePathology: '血行不畅，瘀血内阻',
    diseaseRisks: '心脑血管疾病：冠心病、心绞痛、心肌梗死、脑梗塞。妇科疾病：痛经、闭经、子宫肌瘤、卵巢囊肿。肿瘤倾向：血瘀体质是肿瘤发生的土壤之一。疼痛性疾病：偏头痛、周身刺痛，痛处固定。',
    dietPrinciple: '活血化瘀，行气通络',
    recommendedFoods: [
      '活血食物：山楂、黑木耳、醋、玫瑰花、桃仁、油菜、金桔。',
      '行气食物：洋葱、大蒜、陈皮、佛手。',
      '适量饮用：红葡萄酒、黄酒（有温热之性以助血行）。'
    ],
    strictProhibitions: [
      '寒凉收涩：冰淇淋、冷饮、柿子、乌梅、石榴。',
      '高脂肪、高胆固醇食物：会加重血液粘稠度。',
      '避免久坐不动，运动是活血的最好方式。'
    ]
  },
  '气郁质': {
    corePathology: '肝气郁结，气机失于调达',
    diseaseRisks: '精神类疾病：抑郁症、焦虑症、失眠。妇科疾病：乳腺增生、乳腺纤维瘤、月经不调、痛经。消化系统问题：梅核气（咽部异物感）、胃胀、嗳气、肠易激综合征（irritable bowel syndrome, IBS）。',
    dietPrinciple: '疏肝解郁，理气和胃',
    recommendedFoods: [
      '芳香行气：玫瑰花、茉莉花、佛手、橙子、柑橘、芹菜、茴香、薄荷。',
      '代茶饮：玫瑰花茶、佛手茶、橘皮茶是极佳选择。',
      '适当吃些：小麦（安神）、百合、莲子。'
    ],
    strictProhibitions: [
      '收敛酸涩：乌梅、泡菜、柠檬（过量）。',
      '胀气食物：红薯、糯米（对部分人）。',
      '咖啡、浓茶：易导致神经兴奋，加重焦虑和失眠。'
    ]
  },
  '特禀质': {
    corePathology: '先天禀赋不足，卫外不固',
    diseaseRisks: '过敏性疾病：过敏性鼻炎、过敏性哮喘、荨麻疹、湿疹、过敏性结膜炎。自身免疫性疾病：风险相对较高。',
    dietPrinciple: '益气固表，凉血消风',
    recommendedFoods: [
      '健脾益气：山药、燕麦、小米、红枣、党参（过敏非发作期）。',
      '抗敏食材：灵芝、乌梅、胡萝卜、金针菇。'
    ],
    strictProhibitions: [
      '绝对避免已知过敏原：常见如海鲜、芒果、花生、牛奶、蛋类等，需个体化检测。',
      '慎食"发物"：羊肉、鹅肉、韭菜、香菇、竹笋、螃蟹、酒类，尤其在过敏发作期。',
      '避免不新鲜的食物：含组胺高的不新鲜鱼虾、腌制食品。'
    ]
  }
};




